/* eslint-disable prettier/prettier */

// @mui material components
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import Card from "@mui/material/Card";
// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import "rc-tree/assets/index.css";
import Tree, { TreeNode } from "rc-tree";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { map, filter, find } from "lodash";
import Icon from "@mui/material/Icon";
import TextField from "@mui/material/TextField";
import { Box } from "@mui/material";
import MDTypography from "components/MDTypography";
import ColorPickerCustom from "./componentes/ColorPickerCustom";

import {
  InformacionInicialRoles,
  InsertarRol,
  ActualizarRol,
  getPermisosRoles,
} from "store/roles/rolesActions";

import { store } from "../../store/store";
import toast from "react-hot-toast";

export default function ModificarUsuario() {
  const usuario = store.getState().login.usuario;
  const { state } = useLocation();
  const navigate = useNavigate();
  const { grupos, permisos } = useSelector((state) => state.roles);
  const dispatch = useDispatch();
  const [idRolUsuario, setIdRolUsuario] = useState(state ? state.idRolUsuario : 0);

  const [rolUsuario, setRolUsuario] = useState(state ? state.rolUsuario : "");
  const [invalidRolUsuario, setInvalidRolUsuario] = useState(false);

  const [inicialesRol, setInicialesRol] = useState(state ? state.inicialesRol : "");
  const [invalidIniciales, setInvalidIniciales] = useState(false);

  const [colorRol, setColorRol] = useState(state ? state.colorRol : "#ffffff");
  const [letraRol, setLetraRol] = useState(state ? state.letraRol : "");
  const [descripcion, setDescripcion] = useState(state ? state.descripcion : "");
  const [idEmpresa, setIdEmpresa] = useState(state ? state.idEmpresa : 0);
  const [cadenaPermisosRol, setCadenaPermisosRol] = useState(state ? state.cadenaPermisosRol : "");
  const [permisosAc, setPermisos] = useState([]);

  useEffect(() => {
    InformacionInicialRoles(dispatch);
    if (state != null) {
      consultarPermisos();
    }
  }, [state?.idRolUsuario]);

  const consultarPermisos = async () => {
    const res = await dispatch(getPermisosRoles(state?.idRolUsuario));
    const idPermisos = res
      ? map(res.listaRoles?.permisos, (item) => item.idPermiso.toString())
      : [];
    setPermisos(idPermisos);
  };

  const [mostrarColorPicker, setMostrarColorPicker] = useState(false);

  const saveRol = () => {
    if (!rolUsuario) {
      toast.error("Ingresa el nombre del rol");
      setInvalidRolUsuario(true);
      return false;
    }
    if (!inicialesRol) {
      toast.error("Ingresa las iniciales del rol");
      setInvalidIniciales(true);
      return false;
    }
    var data = {
      idRolUsuario: idRolUsuario,
      rolUsuario: rolUsuario,
      inicialesRol: inicialesRol,
      colorRol: colorRol,
      letraRol: letraRol,
      descripcion: descripcion,
      idEmpresa: idEmpresa,
      cadenaPermisosRol: cadenaPermisosRol,
      userId: usuario.idUsuario,
      permisos: permisosAc,
      activo: true,
    };

    if (state != null) {
      ActualizarRol(dispatch, data);
      navigate("/roles");
    } else {
      InsertarRol(dispatch, data);
      navigate("/roles");
    }
  };

  return (
    <>
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox pt={1} pb={3}>
          <Grid container>
            <Grid item xs={12}>
              <Card>
                <Grid item xs={12} md={12} lg={12}>
                  <MDBox mb={1.5} py={1} px={2} display="flex" justifyContent="space-between">
                    <Button
                      variant="contained"
                      startIcon={<Icon>arrow_back_ios_new</Icon>}
                      color="primary"
                      size="small"
                      style={{ textTransform: "inherit" }}
                      onClick={() => navigate("/roles")}
                    >
                      Regresar
                    </Button>
                    <Button
                      variant="contained"
                      startIcon={<Icon>send</Icon>}
                      color="primary"
                      size="small"
                      style={{ textTransform: "inherit" }}
                      onClick={() => saveRol()}
                    >
                      {state ? "Guardar" : "Agregar"}
                    </Button>
                  </MDBox>
                </Grid>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={5} lg={5}>
                    <MDBox py={3} px={2}>
                      <TextField
                        value={rolUsuario}
                        onChange={(event) => {
                          setRolUsuario(event.target.value);
                        }}
                        onFocus={() => {
                          setInvalidRolUsuario(false);
                        }}
                        onBlur={() => {
                          if (!rolUsuario) setInvalidRolUsuario(true);
                        }}
                        error={invalidRolUsuario}
                        helperText={invalidRolUsuario && "Nombre del rol obligatorio*"}
                        label="Nombre del Rol"
                        variant="outlined"
                        style={{ width: "100%", marginBottom: "1.5rem" }}
                        size="small"
                      />
                      <TextField
                        value={inicialesRol}
                        onChange={(event) => {
                          setInicialesRol(event.target.value);
                        }}
                        onFocus={() => {
                          setInvalidIniciales(false);
                          if (!rolUsuario) {
                            setInvalidRolUsuario(true);
                          }
                        }}
                        onBlur={() => {
                          if (!inicialesRol) setInvalidIniciales(true);
                        }}
                        error={invalidIniciales}
                        helperText={invalidIniciales && "Iniciales del rol obligatorias*"}
                        label="Iniciales del Rol"
                        variant="outlined"
                        style={{ width: "100%", marginBottom: "1.5rem" }}
                        size="small"
                      />
                      <TextField
                        value={descripcion}
                        onChange={(event) => {
                          setDescripcion(event.target.value);
                        }}
                        error={false}
                        helperText=""
                        label="Descripcion del Rol"
                        variant="outlined"
                        style={{ width: "100%", marginBottom: "1.5rem" }}
                        size="small"
                      />
                      <MDBox sx={{ width: "20%", marginBottom: "1.5rem" }}>
                        <MDTypography
                          color="white"
                          sx={{ fontSize: "12px", marginBottom: "4px", display: "block" }}
                        >
                          Color del Rol
                        </MDTypography>
                        {/* Vista previa + botón */}
                        <Box sx={{ display: "flex", alignItems: "center", gap: 2, width: "170px" }}>
                          <Box
                            sx={{
                              width: 40,
                              height: 30,
                              borderRadius: "4px",
                              border: "1px solid #ccc",
                              backgroundColor: colorRol,
                            }}
                          />
                          <Button
                            variant="contained"
                            startIcon={
                              mostrarColorPicker ? (
                                <Icon>expand_less</Icon>
                              ) : (
                                <Icon>expand_more</Icon>
                              )
                            }
                            size="small"
                            color="secondary"
                            style={{ textTransform: "inherit" }}
                            onClick={() => setMostrarColorPicker((prev) => !prev)}
                          >
                            {"Selector"}
                          </Button>
                        </Box>

                        {/* Mostrar el selector solo si se solicita */}
                        {mostrarColorPicker && (
                          <Box mt={2}>
                            <ColorPickerCustom color={colorRol} onChange={setColorRol} />
                          </Box>
                        )}
                      </MDBox>
                    </MDBox>
                  </Grid>
                  <Grid item xs={12} md={7} lg={7}>
                    <MDBox mb={1.5}>
                      <Tree
                        showLine={false}
                        checkable={true}
                        defaultExpandAll={true}
                        checkedKeys={permisosAc}
                        onCheck={(checkedKeys) => {
                          const soloPermisosEspecificos = checkedKeys.filter(
                            (key) => /^[0-9]+$/.test(key) && key !== "0"
                          );
                          setPermisos(soloPermisosEspecificos);
                        }}
                        style={{ fontSize: 12, color: "text" }}
                      >
                        <TreeNode
                          title={
                            <strong style={{ paddingLeft: 5, color: "white" }}>Permisos</strong>
                          }
                          key={0}
                          disabled={false}
                          icon={
                            <Icon fontSize="small" color="primary">
                              lock
                            </Icon>
                          }
                        >
                          {Object.values(grupos).map((grupo) => {
                            const opciones = filter(permisos, (p) => {
                              return p.idGrupoPermiso === grupo.idGrupoPermiso;
                            });
                            return (
                              <TreeNode
                                title={
                                  <strong style={{ paddingLeft: 5, color: "white" }}>
                                    {grupo.grupoPermiso}
                                  </strong>
                                }
                                key={`P${grupo.idGrupoPermiso}`}
                                disabled={false}
                                icon={
                                  <Icon fontSize="small" color="primary">
                                    rule_folder
                                  </Icon>
                                }
                              >
                                {map(opciones, (permiso) => {
                                  const activado = filter(permisosAc, (e) => {
                                    return e === String(permiso.idPermiso);
                                  });
                                  return (
                                    <TreeNode
                                      title={
                                        <strong
                                          style={{
                                            paddingLeft: 5,
                                            color: activado.length == 0 ? "#606161" : "#4CAF50",
                                          }}
                                        >
                                          {permiso.permiso}
                                        </strong>
                                      }
                                      key={permiso.idPermiso}
                                      disabled={false}
                                      icon={
                                        <Icon
                                          fontSize="small"
                                          color={activado.length == 0 ? "secondary" : "success"}
                                        >
                                          key
                                        </Icon>
                                      }
                                    ></TreeNode>
                                  );
                                })}
                              </TreeNode>
                            );
                          })}
                        </TreeNode>
                      </Tree>
                    </MDBox>
                  </Grid>
                </Grid>
              </Card>
            </Grid>
          </Grid>
        </MDBox>
        <Footer />
      </DashboardLayout>
    </>
  );
}
